module.exports = __webpack_public_path__ + "static/slide1-9921db1ace613e0a9bb3e860542d3921.png";